import { render, staticRenderFns } from "./pasos-form.vue?vue&type=template&id=9ac7f45c&"
import script from "./pasos-form.vue?vue&type=script&lang=js&"
export * from "./pasos-form.vue?vue&type=script&lang=js&"
import style0 from "./pasos-form.vue?vue&type=style&index=0&id=9ac7f45c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports